export const disableInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const disallowKeys = ['e', '+', '-'];
  if (disallowKeys.find(key => key === e.key)) {
    e.preventDefault();
  }
};
